// Copyright 2025, University of Maryland, All Rights Reserved
export function formatTimestamp(value: string | null): string | null {
  if (!value) return null

  const parsed = new Date(value)
  if (Number.isNaN(parsed.getTime())) {
    return value
  }

  return parsed.toLocaleString()
}
